import { useEffect, useState } from 'react';
import { PermissionEnum } from '@ui/src';
import { OrganizationType } from '../../types';

const useOngoingMonitoringPanel = ({
  batchApplyOngoingWarning,
  warningGroupId,
  batchApplyWarningIsSuccess,
  type,
  activePermissions,
}: {
  batchApplyOngoingWarning: ({
    id,
    action,
    comment,
    matchStatus,
  }: {
    id: string;
    action: string;
    comment: string;
    matchStatus?: string;
  }) => void;
  warningGroupId: string;
  batchApplyWarningIsSuccess?: boolean;
  type: OrganizationType;
  activePermissions?: PermissionEnum[];
}) => {
  const [applyAllPopupVisible, setApplyAllPopupVisible] = useState(false);
  const [matchStatus, setMatchStatus] = useState('');
  const [action, setAction] = useState('');
  const [comment, setComment] = useState('');

  let aproveAllowed = false;
  let rejectAllowed = false;

  if (
    type === OrganizationType.INDIVIDUAL &&
    activePermissions?.includes(
      PermissionEnum.INDIVIDUAL_CUSTOMERS_AML_APPROVE_ACTION,
    )
  ) {
    aproveAllowed = true;
  } else if (
    type === OrganizationType.CORPORATE &&
    activePermissions?.includes(
      PermissionEnum.CORPORATE_CUSTOMERS_AML_APPROVE_ACTION,
    )
  ) {
    aproveAllowed = true;
  }

  if (
    type === OrganizationType.INDIVIDUAL &&
    activePermissions?.includes(
      PermissionEnum.INDIVIDUAL_CUSTOMERS_AML_REJECT_ACTION,
    )
  ) {
    rejectAllowed = true;
  } else if (
    type === OrganizationType.CORPORATE &&
    activePermissions?.includes(
      PermissionEnum.CORPORATE_CUSTOMERS_AML_REJECT_ACTION,
    )
  ) {
    rejectAllowed = true;
  }

  const onApplyActions = async () => {
    await batchApplyOngoingWarning({
      id: warningGroupId,
      action,
      comment,
      matchStatus,
    });
  };

  useEffect(() => {
    if (batchApplyWarningIsSuccess) {
      setApplyAllPopupVisible(false);
      setComment('');
      setMatchStatus('');
      setAction('');
    }
  }, [batchApplyWarningIsSuccess]);

  return {
    applyAllPopupVisible,
    setApplyAllPopupVisible,
    matchStatus,
    setMatchStatus,
    action,
    setAction,
    comment,
    setComment,
    aproveAllowed,
    rejectAllowed,
    onApplyActions,
  };
};

export default useOngoingMonitoringPanel;
